export default {
  internal: 'Interno',
  customer: 'Cliente',
  partner: 'Parceiro',
  affiliate: 'Afiliado',
  franchisee: 'Franqueado',
  options: [
    { value: 'internal', text: 'Interno' },
    { value: 'customer', text: 'Cliente' },
    { value: 'partner', text: 'Parceiro' },
    { value: 'affiliate', text: 'Afiliado' },
    { value: 'franchisee', text: 'Franqueado' }
  ]
};
